@let gridLayout = layout();
@let stagedId = stagedUserId();
<!-- The stage needs a second tile to make the first one large. -->
@let stageable = mode() === 'main' && visibleUsers().length > 1;
<div class="video-viewport" #viewport>
  <div
    class="video-grid"
    [style.visibility]="gridLayout ? null : 'hidden'"
    [style.width.px]="gridLayout?.gridWidth"
    [style.gap.px]="gridGap">
    @for (user of visibleUsers(); track user.id; let idx = $index) {
      @let tileSize = (idx === 0 && gridLayout?.stage) || gridLayout?.tile;
      <andor-video-tile
        (fullscreenRequested)="onFullscreenRequested($event)"
        (stageToggled)="onStageToggled($event)"
        [userId]="user.id"
        [mode]="mode()"
        [staged]="user.id === stagedId"
        [stageable]="stageable"
        [attachDelay]="idx * 75"
        [style.width.px]="tileSize?.width"
        [style.height.px]="tileSize?.height"></andor-video-tile>
    }
  </div>
</div>
<dialog #fullscreenDialog class="fullscreen-dialog" (close)="onDialogClose()">
  <!-- Element fullscreen targets this wrapper: browsers refuse
       requestFullscreen() on <dialog> elements themselves. -->
  <div class="fullscreen-target" #fullscreenTarget>
    @if (fullscreenUser(); as user) {
      <andor-video-fullscreen
        [userId]="user.id"
        (close)="stopFullscreen()"></andor-video-fullscreen>
    }
  </div>
</dialog>
